import * as z from "zod";
import { Product, ProductSchema } from "./Product";

export const BaseOrderLineSchema = z.object({
  id: z.string(),
  quantity: z.number(),
  title: z.string(),
  description: z.string(),
  unitPrice: z.number(),
  productId: z.nullable(z.optional(z.string())),
  product: z.nullable(z.optional(ProductSchema)),
  parentId: z.nullable(z.optional(z.string())),
});
export type OrderLine = z.infer<typeof BaseOrderLineSchema> & {
  children: Array<OrderLine>; // Patch the type. Zod v4 is not up to snuff as of yet
};
export const OrderLineSchema: z.ZodType<OrderLine> = BaseOrderLineSchema.extend(
  {
    get children() {
      return z.array(OrderLineSchema);
    },
  }
);

export function createDefault(): OrderLine {
  return {
    id: "",
    quantity: 0,
    productId: "",
    product: Product.createDefault(),
    unitPrice: 0,
    title: "Placeholder",
    description: "Placeholder",
    children: [],
  };
}
